import React from 'react';
import { View, StyleSheet } from 'react-native';
import { FormSection, OptionCard } from '@/components';
import { IBulletinFormValues, BulletinRecipientType, BulletinFormFieldHandler } from '@/types/admin/bulletins';

interface RecipientOptionsSectionProps {
  formData: IBulletinFormValues;
  onFieldChange: BulletinFormFieldHandler;
}

const recipientOptions = [
  {
    value: 'all' as BulletinRecipientType,
    title: 'All',
    subtitle: 'Current and future lease residents',
  },
  {
    value: 'current' as BulletinRecipientType,
    title: 'Current',
    subtitle: 'Only residents with an active lease',
  },
  {
    value: 'future' as BulletinRecipientType,
    title: 'Future',
    subtitle: 'Only residents with a future lease',
  },
  {
    value: 'notice' as BulletinRecipientType,
    title: 'Notice',
    subtitle: 'Only residents with lease notices',
  },
];

export const RecipientOptionsSection: React.FC<RecipientOptionsSectionProps> = ({
  formData,
  onFieldChange,
}) => {
  return (
    <FormSection title="Recipients">
      <View style={styles.container}>
        <View style={styles.optionsGrid}>
          {recipientOptions.map((option) => (
            <View key={option.value} style={styles.optionWrapper}>
              <OptionCard
                title={option.title}
                subtitle={option.subtitle}
                value={formData.recipientType === option.value}
                onPress={() => onFieldChange('recipientType', option.value)}
                type="radio"
              />
            </View>
          ))}
        </View>
      </View>
    </FormSection>
  );
};

const styles = StyleSheet.create({
  container: {
    // No additional styles needed
  },
  optionsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginHorizontal: -6,
  },
  optionWrapper: {
    width: '50%',
    paddingHorizontal: 6,
  },
});
